import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import UploadPrematchedAccountPairs from './UploadPrematchedAccountPairs';
import UploadPrematchedContactPairs from './UploadPrematchedContactPairs';
import Dialog from '../shared/Dialog';
import NotFound from '../shared/NotFound';
import { getOrderById, uploadPrematchedPairs, uploadComplete } from '../../actions/order';
import { openDialog, closeDialog } from '../../actions/dialog';
import { storeWithExpiration } from '../../utils/common';

export class UploadPrematchedContainer extends React.Component {
  static propTypes = {
    closeDialogAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    getOrderByIdAction: PropTypes.func.isRequired,
    order: PropTypes.object,
    orderId: PropTypes.string.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    uploadPrematchedPairsAction: PropTypes.func.isRequired,
    uploadCompleteAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    order: null,
  };

  constructor(props) {
    super(props);
    this.toggleDialog = this.toggleDialog.bind(this, 'uploadCompleteDialog');
  }

  componentWillMount = () => {
    const { orderId, getOrderByIdAction } = this.props;

    const token = storeWithExpiration.get('token');
    getOrderByIdAction(orderId, token);
  };

  uploadCompleteFunction = () => {
    const { orderId, uploadCompleteAction } = this.props;
    const token = storeWithExpiration.get('token');
    uploadCompleteAction(orderId, token);
  };

  toggleDialog = id => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (dialog.show) {
      closeDialogAction(id);
    } else {
      openDialogAction(id);
    }
  };

  renderUploadCompleteDialog = () => (
    <div>
      <p>Are you sure you have uploaded your pre-matched data correctly?</p>
      <p>If not, you can click cancel and re-upload the files.</p>
      <p>
        By clicking &ldquo;Complete Upload&rdquo;, your current account and/or contact pre-matched
        files will be locked and used for processing.
      </p>
      <p>
        This is a one-time process and cannot be reversed. Files cannot be re-uploaded once
        confirmed.
      </p>
    </div>
  );

  render() {
    const { dialog, order, orderId, uploadPrematchedPairsAction } = this.props;

    return order && order.matchedPairsProvided === 'UPLOAD_PENDING' ? (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="pull-right">
              <button
                className="btn btn-primary"
                onClick={() => {
                  this.toggleDialog('uploadCompleteDialog');
                }}
              >
                Complete Upload
              </button>
            </div>
            <h1 className="card-title">
              <Link to="/orders">
                <i className="fa fa-angle-left" /> Upload Prematched Pairs
              </Link>
            </h1>
            <div className="card-block">
              <div className="row">
                <div className="col-md-6">
                  <UploadPrematchedAccountPairs
                    orderId={orderId}
                    uploadPrematchedPairsFunction={uploadPrematchedPairsAction}
                  />
                  <UploadPrematchedContactPairs
                    orderId={orderId}
                    uploadPrematchedPairsFunction={uploadPrematchedPairsAction}
                  />
                </div>
                <div className="col-md-6 card card-box order-box">
                  <br />
                  <h4>CSV file should be in the following format with header:</h4>
                  <p>
                    ProviderId,CustomerId<br />
                    02903,001AAX0000IY<br />
                    02906,001BBX0000IZ<br />
                  </p>
                  <p>
                    <small>
                      *Note: Previously uploaded files will be overwritten on new upload.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {dialog.id === 'uploadCompleteDialog' && dialog.show ? (
          <Dialog
            cancelFunction={this.toggleDialog}
            cancelText="Cancel"
            content={this.renderUploadCompleteDialog()}
            id={dialog.id}
            show={dialog.show}
            successFunction={this.uploadCompleteFunction}
            successText="Complete Upload"
            title="Upload Complete Confirmation"
          />
        ) : null}
      </div>
    ) : (
      <NotFound />
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { dialog, orderList } = state;
  const currOrder = orderList.get('currentOrder');
  const order = currOrder.get('order');
  const { orderId } = ownProps.params;
  return { dialog, order, orderId };
}

export default connect(mapStateToProps, {
  closeDialogAction: closeDialog,
  getOrderByIdAction: getOrderById,
  openDialogAction: openDialog,
  uploadCompleteAction: uploadComplete,
  uploadPrematchedPairsAction: uploadPrematchedPairs,
})(UploadPrematchedContainer);
